import AboutUsModule from './AboutUsModule';
import AboutUsSiteContainer from './AboutUsSiteContainer';
import styles from './AboutUsImageAndText.module.css';
import { ReactNode } from 'react';

interface Props {
  images: {
    imagePath: string;
    imageAlt: string;
    verticalFocus?: 'top' | 'center' | 'bottom';
  }[];
  children: ReactNode;
  header: ReactNode;
  /* Whether the image should appear above the header on mobile devices */
  showImageFirstOnMobile?: boolean;
  /* Whether the image(s) should appear on the right on desktop devices */
  imageOnRight?: boolean;
  background: Parameters<typeof AboutUsModule>[0]["background"];
}

const AboutUsImageAndText = (props: Props) => (
  <AboutUsModule background={props.background}>
    <AboutUsSiteContainer>
      <div className={styles.container + ' ' + (props.imageOnRight ? styles.containerImageOnRight : '')}>
        {props.showImageFirstOnMobile
          ? (
            <>
              {renderImages(props)}
              {renderHeader(props)}
            </>
          )
          : (
            <>
              {renderHeader(props)}
              {renderImages(props)}
            </>
          )
        }
        <div className={styles.textContainer}>
          {props.children}
        </div>
      </div>
    </AboutUsSiteContainer>
  </AboutUsModule>
);

function renderHeader(props: Props) {
  return (
    <div className={styles.headerContainer}>
      {props.header}
    </div>
  );
}
function renderImages(props: Props) {
  return (
    <div className={styles.imageContainer + ' ' + (props.images.length > 2 ? styles.imageContainerWithMultipleImages : '')}>
      {props.images.map((x, index) => <div key={index} className={styles.image}><img className={x.verticalFocus && styles['imageFocus__' + x.verticalFocus]} src={x.imagePath} alt={x.imageAlt} /></div>)}
    </div>
  );
}

export default AboutUsImageAndText;